import React from 'react'
import { l } from '@ds/index'
import cx from 'classnames'

import { CurrentPlanBreakdown } from './CurrentPlanBreakdown'
import { TargetPlanCard } from './TargetPlanCard'
import { MigrationPlansViewReady } from './useMigrationPlansView'

import cm from './MigrationPlansView.module.css'

interface PriceUpPlansViewProps {
  migrationViewData: MigrationPlansViewReady
}

export const PriceUpPlansView = ({ migrationViewData }: PriceUpPlansViewProps) => {
  return (
    <div className={cx(cm.contentBox, cm.stackedBox, 'bg-white p-a-md')}>
      <div className={cm.stackedIntro}>
        <h2 className="text-heading-sm">{l.translate('What’s changing?')}</h2>
        <p className="m-t-xxs">
          {l.translate(
            'Our new plans are based on Active Contacts, the people you reach each month, not everyone stored in your account.',
          )}
        </p>
      </div>
      <div className={cx(cm.planColumn, cm.stackedPlanColumn)}>
        <TargetPlanCard migrationViewData={migrationViewData} />
      </div>
      <CurrentPlanBreakdown className={cm.stackedBreakdown} />
    </div>
  )
}
